module.exports = __webpack_public_path__ + "media/images/icon/icons8-FAQ-57d93434ccb8e97f28e39eeeaa223036.png";